module.exports = __webpack_public_path__ + "e60a2cd2e8e58d910e56b9535beb350b.png";